import { createFileRoute, Outlet } from "@tanstack/react-router";

// Locale layout. All app routes live under /$locale (+ optional {-$schoolyear}), mirroring
// portal's prefix(":locale", prefix(":schoolyear?", ...)) structure.
export const Route = createFileRoute("/$locale")({
  component: () => <Outlet />,
});
